/* eslint-disable max-lines */
import React from 'react';
import {Button, Form, Grid, Modal} from 'semantic-ui-react';
import {connect} from 'react-redux';
import {Actions} from '../../../../common/actions';
import useClient from './customHooks/useClient';
import {mapListToDropdownList} from '../../../../floatingInventory/utils/commonUtils';
import ButtonFloatClientFiles from '../../common/uploadFiles/buttonFloatClientFiles';
import {formValidationsClient} from '../../../utils';

const ClientManagementForm = ({
  data,
  dealerId,
  exonerationsList,
  isUserTde,
  setData,
  cities,
  provinces,
  clientTypes,
  minValue,
  fetchVerifyFloatClient,
  fetchFlInventoryAttachments,
  contTypesListCed,
  contTypesListRuc,
  contTypesListPass,
  closeModal,
  fetchClientManagementInfo,
  code,
  dealerReserve,
  clearClientManagement,
  fetchClientManagementList,
  addClientManagement,
  updateClientManagement,
  addMessageBoxError,
  currentFlUserGroup,
  listDealers,
  dealerRuc,
}) => {
  const {
    'actions': {
      handleDocumentChange,
      handleSendData,
      handleChange,
      handleClientTypeChange,
      handleDocumentRepChange,
      handleInputTextChange,
    },
    'data': {
      dataError,
      isAvailable,
      clientFilesKey,
    },
  } = useClient({
    data,
    setData,
    exonerationsList,
    dealerId,
    isUserTde,
    minValue,
    formValidationsClient,
    fetchFlInventoryAttachments,
    fetchClientManagementInfo,
    closeModal,
    code,
    clearClientManagement,
    fetchClientManagementList,
    addClientManagement,
    updateClientManagement,
    addMessageBoxError,
    fetchVerifyFloatClient,
    currentFlUserGroup,
    dealerRuc,
  });
  return (
    <>
      <div>
        <Grid
          stackable
          fluid
          columns={3}
          divided
          className="no-space"
          textAlign="left"
        >
          <Grid.Column className='client-spacing-top spacing-floating-client' >
            <Grid.Row>
              <Form.Select
                disabled={!isAvailable}
                required
                fluid
                className='modal-field-warning'
                label="TIPO DE CLIENTE"
                placeholder="SELECCIONE EL TIPO DE CLIENTE"
                name="clientType"
                value={data.clientType}
                options={mapListToDropdownList(
                  clientTypes,
                  {
                    'keys': ['code'],
                    'values': ['code'],
                    'texts': ['description'],
                  }
                )}
                error={dataError.clientTypeError}
                onChange={(e, {name, value}) =>
                  handleClientTypeChange(name, value, formValidationsClient.clientType(data))
                }
                onBlur={(e, {name, value}) =>
                  handleClientTypeChange(name, value, formValidationsClient.clientType(data))
                }
              />
            </Grid.Row>
            <Grid.Row>
              {data.clientType === '001' && (
                <>
                  <Form.Input
                    disabled={!isAvailable}
                    className='modal-field-warning'
                    fluid
                    required={data.clientType === '001'}
                    label="% DE DISCAPACIDAD"
                    placeholder="Ej. 90"
                    name="discapacityPerc"
                    value={data.discapacityPerc}
                    error={dataError.discapacityPercError}
                    onChange={(e, {name, value}) => handleInputTextChange(
                      e,
                      {name, value},
                      formValidationsClient.discapacityPerc(data),
                      {minValue}
                    )}
                    onBlur={({'target': {name, value}}) =>
                      handleChange(
                        name,
                        value,
                        formValidationsClient.discapacityPerc(data),
                        {minValue}
                      )
                    }
                  />
                </>
              )}
            </Grid.Row>
            <Grid.Row>
              <Form.Input
                disabled={!isAvailable}
                readOnly
                fluid
                className='modal-field-warning'
                label="% DE EXONERACIÓN"
                value={data.exonerationPerc}
              />
            </Grid.Row>
            <Grid.Row>
              <Form.Group grouped className="group-custom-floating">
                <Form.Group inline widths={16} className='no-space-check-client'>
                  <label className="main field-client-custom">CERTIFICACIÓN DE VERIFICACIÓN</label>
                  <Form.Checkbox
                    disabled={!isAvailable}
                    name="certificate"
                    className='check-client-custom'
                    value={data.certificate}
                    checked={data.certificate === 'S'}
                    onChange={(e, {name, value}) => {
                      const valueToUpdate = value === 'S' ? 'N' : 'S';
                      handleChange(name, valueToUpdate, formValidationsClient.certificate(data));
                    }}
                  />
                  {
                    code &&
                      <ButtonFloatClientFiles
                        disabled={!isAvailable}
                        code={clientFilesKey}
                        fileType={'infoCertification'}
                        title={'CERTIFICACIÓN DE VERIFICACIÓN DE LA INFORMACIÓN'}
                      />
                  }
                </Form.Group>
              </Form.Group>
            </Grid.Row>
            <Grid.Row>
              <Form.Group inline widths={16}>
                <Form.Select
                  disabled={!isAvailable}
                  required
                  fluid
                  className='modal-field-warning'
                  label="CÓD. CONTRIBUYENTE"
                  placeholder="SELECCIONE EL CÓDIGO DE CONTRIBUYENTE"
                  name="contributorCode"
                  value={data.documentType === 'C' ? 'P' : data.contributorCode}
                  options={mapListToDropdownList(
                    data.documentType === 'P' ?
                      contTypesListPass :
                      (data.documentType === 'R' ? contTypesListRuc :
                        (data.documentType === 'C' ? contTypesListCed : [])
                      ),
                    {
                      'keys': ['code'],
                      'values': ['code'],
                      'texts': ['description'],
                    }
                  )}
                  error={dataError.contributorCodeError}
                  onChange={(e, {name, value}) =>
                    handleChange(name, value, formValidationsClient.contributorCode(data))
                  }
                  onBlur={(e, {name, value}) =>
                    handleChange(name, value, formValidationsClient.contributorCode(data))
                  }
                />
              </Form.Group>
            </Grid.Row>
            <Grid.Row inline widths={16}>
              <Form.Select
                disabled={code || !isAvailable || !isUserTde}
                required
                fluid
                className='modal-field-warning'
                label="DEALER"
                placeholder="SELECCIONE EL DEALER QUE CORRESPONDA"
                name="dealerRuc"
                value={data.dealerRuc}
                options={mapListToDropdownList(
                  listDealers,
                  {
                    'keys': ['identification'],
                    'values': ['identification'],
                    'texts': ['name'],
                  },
                  false
                )}
                error={dataError.contributorCodeError}
                onChange={(e, {name, value}) =>
                  handleChange(name, value, formValidationsClient.dealerRuc(data))
                }
                onBlur={(e, {name, value}) =>
                  handleChange(name, value, formValidationsClient.dealerRuc(data))
                }
              />
            </Grid.Row>
          </Grid.Column>
          <Grid.Column className='spacing-floating-client'>
            <Grid.Row>
              {data.documentType && <Form.Group inline widths={16} className='wrapper-client-radio'>
                <label className="main field-client-custom">TIPO DE DOCUMENTO</label>
                <div className="wrapper-client-radio-document">
                  {data.clientType === '001' &&
                  <Form.Radio
                    disabled={!isAvailable}
                    color='blue'
                    label="CI"
                    name="documentType"
                    value="C"
                    checked={data.documentType === 'C'}
                    onChange={(e, {name, value}) => handleChange(name, value)}
                  />}
                  {['002', '005'].includes(data.clientType) &&
                  <Form.Radio
                    disabled={!isAvailable}
                    label="RUC"
                    name="documentType"
                    value="R"
                    checked={data.documentType === 'R'}
                    onChange={(e, {name, value}) => handleChange(name, value)}
                  />}
                  { data.clientType === '002' &&
                  <Form.Radio
                    disabled={!isAvailable}
                    label="PASAPORTE"
                    name="documentType"
                    value="P"
                    checked={data.documentType === 'P'}
                    onChange={(e, {name, value}) => handleChange(name, value)}
                  />}
                </div>
              </Form.Group>}
            </Grid.Row>
            <Grid.Row>
              <Form.Group className='form-group-floating-id'>
                <Form.Input
                  disabled={code || !isAvailable}
                  autoComplete='off'
                  className='client-input-id modal-field-warning'
                  fluid
                  required
                  min={10}
                  max={15}
                  width={12}
                  label="N° ID"
                  placeholder="Ej. 1805102074"
                  name="document"
                  value={data.document}
                  error={dataError.documentError}
                  onChange={(e, {name, value}) => handleInputTextChange(
                    e,
                    {name, value},
                    formValidationsClient.document(data),
                  )}
                  onBlur={({'target': {name, value}}) => {
                    handleDocumentChange(
                      name,
                      value,
                      formValidationsClient.document(data),
                    );
                    fetchFlInventoryAttachments(`${value}/${data.dealerRuc}`);
                  }}
                />
                {
                  code &&
                    <ButtonFloatClientFiles
                      disabled={!isAvailable}
                      code={clientFilesKey}
                      fileType={'clientId'}
                      title={'DOCUMENTOS DE IDENTIFICACIÓN'}
                      className='client-file-button-document'
                    />
                }
              </Form.Group>
            </Grid.Row>
            <Grid.Row>
              {data.documentType !== 'R' &&
                <Form.Input
                  disabled={!isAvailable}
                  required
                  fluid
                  className='modal-field-warning'
                  label="NOMBRES"
                  placeholder="NOMBRES"
                  name="names"
                  value={data.names}
                  error={dataError.namesError}
                  onChange={(e, {name, value}) => handleInputTextChange(
                    e,
                    {name, value},
                    formValidationsClient.names(data),
                  )}
                  onBlur={({'target': {name, value}}) =>
                    handleChange(name, value, formValidationsClient.names(data))
                  }
                />
              }
            </Grid.Row>
            <Grid.Row>
              <Form.Input
                disabled={!isAvailable}
                required
                fluid
                className='modal-field-warning'
                label={data.documentType === 'R' ? 'RAZÓN SOCIAL' : 'APELLIDOS'}
                placeholder={data.documentType === 'R' ? 'RAZÓN SOCIAL' : 'APELLIDOS'}
                name="lastNames"
                value={data.lastNames}
                error={dataError.lastNamesError}
                onChange={(e, {name, value}) => handleInputTextChange(
                  e,
                  {name, value},
                  formValidationsClient.lastNames(data),
                )}
                onBlur={({'target': {name, value}}) =>
                  handleChange(name, value, formValidationsClient.lastNames(data))
                }
              />
            </Grid.Row>
            <Grid.Row>
              <Form.Group grouped className="group-custom-floating spacing-floating-client">
                <Form.Group inline widths={16} className='no-space-check-client'>
                  <label className="field-client-custom">REPRESENTANTE LEGAL:</label>
                  <Form.Checkbox
                    disabled={!isAvailable}
                    className='check-client-custom '
                    name="hasLegalRepresentative"
                    value={data.hasLegalRepresentative}
                    checked={data.hasLegalRepresentative === 'S'}
                    onChange={(e, {name, value}) => {
                      const valueToUpdate = value === 'S' ? 'N' : 'S';
                      handleChange(name, valueToUpdate);
                    }}
                  />
                </Form.Group>
                {data.hasLegalRepresentative === 'S' && (
                  <>
                    <Form.Group inline widths={16} className='wrapper-client-radio'>
                      <label className="main field-client-custom">TIPO DE DOCUMENTO</label>
                      <Form.Radio
                        disabled={!isAvailable}
                        color='blue'
                        label="CI"
                        name="legalRepresentativeType"
                        value="C"
                        checked={data.legalRepresentativeType === 'C'}
                        onChange={(e, {name, value}) => handleChange(name, value)}
                      />
                      <Form.Radio
                        disabled={!isAvailable}
                        label="RUC"
                        name="legalRepresentativeType"
                        value="R"
                        checked={data.legalRepresentativeType === 'R'}
                        onChange={(e, {name, value}) => handleChange(name, value)}
                        error={dataError.legalRepresentativeTypeError}
                      />
                      <Form.Radio
                        disabled={!isAvailable}
                        label="PASAPORTE"
                        name="legalRepresentativeType"
                        value="P"
                        checked={data.legalRepresentativeType === 'P'}
                        onChange={(e, {name, value}) => handleChange(name, value)}
                      />
                    </Form.Group>
                    <Form.Input
                      disabled={!isAvailable}
                      fluid
                      min={10}
                      max={15}
                      width={12}
                      label="N° ID"
                      placeholder="Ej. 1805102074"
                      name="legalRepresentativeId"
                      className='modal-field-warning'
                      value={data.legalRepresentativeId}
                      error={dataError.legalRepresentativeIdError}
                      onChange={(e, {name, value}) => handleInputTextChange(
                        e,
                        {name, value},
                        formValidationsClient.legalRepresentativeId(data),
                      )}
                      onBlur={({'target': {name, value}}) => handleDocumentRepChange(
                        name,
                        value,
                        formValidationsClient.legalRepresentativeId(data),
                      )}
                    />
                    <Form.Input
                      disabled={!isAvailable}
                      fluid
                      className='modal-field-warning'
                      label={data.legalRepresentativeType === 'R' ? 'RAZÓN SOCIAL' : 'NOMBRE COMPLETO'}
                      placeholder={data.legalRepresentativeType === 'R' ? 'RAZÓN SOCIAL' : 'APELLIDOS Y NOMBRES'}
                      name="legalRepresentativeName"
                      value={data.legalRepresentativeName}
                      error={dataError.legalRepresentativeNameError}
                      onChange={(e, {name, value}) => handleInputTextChange(
                        e,
                        {name, value},
                        formValidationsClient.legalRepresentativeName(data),
                      )}
                      onBlur={({'target': {name, value}}) =>
                        handleChange(
                          name,
                          value,
                          formValidationsClient.legalRepresentativeName(data),
                        )
                      }
                    />
                  </>
                )}
              </Form.Group>
            </Grid.Row>
          </Grid.Column>
          <Grid.Column className='spacing-floating-client'>
            <Grid.Row>
              <Form.Input
                disabled={!isAvailable}
                fluid
                className='modal-field-warning'
                label="TELÉFONO"
                placeholder="Ej. 0998880000"
                name="phoneNumber"
                value={data.phoneNumber}
                error={dataError.phoneNumberError}
                onChange={(e, {name, value}) => handleInputTextChange(
                  e,
                  {name, value},
                  formValidationsClient.phoneNumber(data),
                )}
                onBlur={({'target': {name, value}}) =>
                  handleChange(
                    name,
                    value,
                    formValidationsClient.phoneNumber(data),
                  )
                }
              />
            </Grid.Row>
            <Grid.Row>
              <Form.Input
                disabled={!isAvailable}
                fluid
                label="EMAIL"
                className='modal-field-warning'
                placeholder="Ej. juan.perez@email.com"
                name="email"
                value={data.email}
                error={dataError.emailError}
                onChange={(e, {name, value}) => handleInputTextChange(
                  e,
                  {name, value},
                  formValidationsClient.email(data),
                )}
                onBlur={({'target': {name, value}}) =>
                  handleChange(name, value, formValidationsClient.email(data))
                }
              />
            </Grid.Row>
            <Grid.Row>
              <Form.Input
                disabled={!isAvailable}
                fluid
                label="DIRECCIÓN"
                className='modal-field-warning'
                placeholder="Ej. Av. MANUEL CÓRDOVA GALARZA SN"
                name="location"
                value={data.location}
                error={dataError.locationError}
                onChange={(e, {name, value}) => handleInputTextChange(
                  e,
                  {name, value},
                  formValidationsClient.location(data),
                )}
                onBlur={({'target': {name, value}}) =>
                  handleChange(name, value, formValidationsClient.location(data))
                }
              />
            </Grid.Row>
            <Grid.Row>
              <Form.Select
                disabled={!isAvailable}
                fluid
                label="CIUDAD"
                className='modal-field-warning'
                placeholder="SELECCIONE LA CIUDAD"
                name="city"
                value={data.city}
                search
                options={
                  mapListToDropdownList(
                    cities,
                    {
                      'keys': ['code'],
                      'values': ['code'],
                      'texts': ['description'],
                    }
                  )}
                error={dataError.cityError}
                onChange={(e, {name, value}) =>
                  handleChange(name, value, formValidationsClient.city(data))
                }
                onBlur={(e, {name, value}) =>
                  handleChange(name, value, formValidationsClient.city(data))
                }
              />
            </Grid.Row>
            <Grid.Row>
              <Form.Select
                disabled={!isAvailable}
                fluid
                label="PROVINCIA"
                className='modal-field-warning'
                placeholder="SELECCIONE LA PROVINCIA"
                name="province"
                value={data.province}
                search
                options={
                  mapListToDropdownList(
                    provinces,
                    {
                      'keys': ['code'],
                      'values': ['code'],
                      'texts': ['description'],
                    }
                  )}
                error={dataError.provinceError}
                onChange={(e, {name, value}) =>
                  handleChange(name, value, formValidationsClient.province(data))
                }
                onBlur={(e, {name, value}) =>
                  handleChange(name, value, formValidationsClient.province(data))
                }
              />
            </Grid.Row>
            <Grid.Row>
              <Form.Input
                disabled={!isAvailable}
                fluid
                readOnly
                className='modal-field-warning'
                label="PAÍS"
                value={'ECUADOR'}
              />
            </Grid.Row>
            <Grid.Row>
              <Form.Group inline>
                {
                  code &&
                    <>
                      <label className="main field-client-custom">OTROS ARCHIVOS</label>
                      <ButtonFloatClientFiles
                        disabled={!isAvailable}
                        code={clientFilesKey}
                        fileType={'others'}
                        title={'OTROS ARCHIVOS'}
                        className='client-file-button-certification'
                      />
                    </>
                }
              </Form.Group>
            </Grid.Row>
          </Grid.Column>
        </Grid>
        <Modal.Actions className='client-save-button'>
          <Button onClick={closeModal}>CERRAR</Button>
          <Button
            positive
            type="submit"
            onClick={() => handleSendData()}
            disabled={!isAvailable}
          >
            {'GRABAR'}
          </Button>
        </Modal.Actions>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const {
    id,
    documentType,
    document,
    legalRepresentativeType,
    names,
    lastNames,
    clientType,
    certificate,
    discapacityPerc,
    hasLegalRepresentative,
    legalRepresentativeId,
    legalRepresentativeName,
    location,
    city,
    province,
    country,
    phoneNumber,
    email,
    blockTable,
    contributorCode,
    exonerationPerc,
    dealerRuc,
  } = state.clientManagementForm.values;
  return {
    'isUserTde': state.session.isUserFromTDE,
    'dealerId': state.session.dealerId,
    'exonerationsList': state.exemptionManagment.list,
    'provinces': state.extraData.provinces,
    'cities': state.extraData.cities,
    'clientTypes': state.extraData.clientTypes,
    'minValue': state.exemptionManagment.minValue,
    'contTypesListCed': state.extraData.contTypesListCed,
    'contTypesListRuc': state.extraData.contTypesListRuc,
    'contTypesListPass': state.extraData.contTypesListPass,
    'currentFlUserGroup': state.floatingInventory.currentFlUserGroup,
    'listDealers': state.dealer.list,
    'listClients': [],
    'data': {
      id,
      documentType,
      document,
      legalRepresentativeType,
      names,
      lastNames,
      clientType,
      certificate,
      discapacityPerc,
      hasLegalRepresentative,
      legalRepresentativeId,
      legalRepresentativeName,
      location,
      city,
      province,
      country,
      phoneNumber,
      email,
      blockTable,
      contributorCode,
      exonerationPerc,
      dealerRuc,
    },
  };
};

const {
  addMessageBoxError,
  addClientManagement,
  clearClientManagement,
  fetchClientManagementInfo,
  fetchClientManagementList,
  fetchVerifyFloatClient,
  fetchFlInventoryAttachments,
  setClientValue,
  updateClientManagement,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  addClientManagement,
  clearClientManagement,
  fetchClientManagementList,
  fetchClientManagementInfo,
  fetchVerifyFloatClient,
  fetchFlInventoryAttachments,
  updateClientManagement,
  'setData': setClientValue,
})(ClientManagementForm);
